import { apiClient } from './api-client';

export type AutoPublished = { versionId: string; version: number } | null;

export type ShareLink = {
  id: string;
  token: string;
  flowId: string;
  tenantId: string;
  versionId: string | null;
  createdBy: string;
  createdAt: string;
  revokedAt: string | null;
  revokedBy: string | null;
  accessCount: number;
  lastAccessedAt: string | null;
  /** Set when the link creation automatically published the flow's latest version. */
  autoPublished: AutoPublished;
};

export const shareLinksApi = {
  async createShareLink(flowId: string, versionId?: string): Promise<ShareLink> {
    const { data } = await apiClient.post(`/flows/${flowId}/share-links`, { versionId });
    return data;
  },

  async getShareLinks(flowId: string) {
    const { data } = await apiClient.get(`/flows/${flowId}/share-links`);
    return data;
  },

  async revokeShareLink(token: string) {
    const { data } = await apiClient.delete(`/share-links/${token}`);
    return data;
  },

  async getSharedFlow(token: string) {
    const { data } = await apiClient.get(`/shared/${token}`);
    return data;
  },

  /**
   * Start a real run from a share link. Anonymous — the token is the only
   * credential, and the server derives tenant and version from it, never from
   * anything the client sends.
   */
  async createSession(token: string) {
    const { data } = await apiClient.post(`/shared/${token}/session`);
    return data;
  },
};
